import * as React from 'react';

import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { PersonProfilePage, PersonProfilePageParams } from './model';
import { PersonProfilePageView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';

export const PersonProfilePageRoute = (model : (params : PersonProfilePageParams) => PersonProfilePage, appWrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <PersonProfilePageView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : PersonProfilePageParams {
    let id = parseInt(request.params['id'] || '');
    if (isNaN(id)) throw new Error('PersonProfilePage: id param is required and must be numeric.');
    return new PersonProfilePageParams(id);
}


// WEBPACK FOOTER //
// ./apps/portcall/personprofilepage/route.tsx